import $ from "jquery";

$(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const category = urlParams.get("category");
  if (!category) {
    $(".animate:first").addClass(
      "animate__animated animate__fast animate__fadeIn"
    );
    $("section:first .animate").addClass(
      "animate__animated animate__fast animate__fadeIn"
    );
  } else {
    //remove animations on filtered content
    $(".animate:first").removeClass(
      "animate animate__animated animate__faster animate__fadeIn"
    );
    $("section:not(section:first) .animate").removeClass(
      "animate animate__animated animate__faster animate__fadeIn"
    );
  }

  /* Every time the window is scrolled ... */
  $(window).on("scroll", function () {
    /* Check the location of each desired element */
    $(".animate").each(function (i, obj) {
      var top_of_object = $(this).offset().top;
      var top_of_window = $(window).scrollTop();

      /* If the object is completely visible in the window, add animation class to trigger it */
      if (top_of_window + (window.innerHeight - 200) >= top_of_object) {
        if (!$(this).hasClass("animate__animated")) {
          $(this).addClass("animate__animated");

          if($(this).hasClass('value-title')){
            $(this).addClass('animate__fadeInDown');
          }

          if($(this).hasClass('value') ){
            $(this).addClass('animate__fadeIn');
          }

          if($(this).hasClass('values-content'))
          {
            $(this).addClass('animate__fadeIn animate__delay-1s animate__fast');
          }

          if($(this).hasClass('left-content'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }

          if($(this).hasClass('right-content'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }

          if($(this).hasClass('left-content-container'))
          {
            $(this).addClass('animate__fadeIn animate__fast');

            $(this).children('h2').children('img').addClass('animate__animated animate__zoomIn animate__faster');
            $(this).children('h2').addClass('delay2 animate__animated animate__zoomIn animate__faster');
            
            $(this).children('p:last-child').addClass('delay5 animate__animated animate__zoomIn animate__faster');
            $(this).children('a').addClass('delay4 animate__animated animate__zoomIn animate__faster');
            $(this).children('p').addClass('delay3 animate__animated animate__zoomIn animate__faster');
            $(this).children('div').addClass('delay6 animate__animated animate__zoomIn animate__faster');
          }

          if($(this).hasClass('right-content-container'))
          {
            $(this).addClass('animate__fadeIn animate__fast');

            $(this).children('h2').children('img').addClass('animate__animated animate__zoomIn animate__faster');
            $(this).children('h2').addClass('delay2 animate__animated animate__zoomIn animate__faster');
        
            $(this).children('p:last-child').addClass('delay5 animate__animated animate__zoomIn animate__faster');
            $(this).children('a').addClass('delay4 animate__animated animate__zoomIn animate__faster');
            $(this).children('p').addClass('delay3 animate__animated animate__zoomIn animate__faster');
            $(this).children('div').addClass('delay6 animate__animated animate__zoomIn animate__faster');

          }

          if($(this).hasClass('left-content-bg'))
          {
            $(this).addClass('animate__fadeInDown animate__faster');
          }

          if($(this).hasClass('accordion-item'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }

          if($(this).hasClass('right-content-bg'))
          {
            $(this).addClass('animate__fadeIn animate__faster');
          }

          if($(this).hasClass('title')){
            $(this).addClass('animate__fadeIn animate__faster');
          }

          if($(this).hasClass('column')){
            $(this).addClass('animate__fadeInUp animate__faster');
          }

          if($(this).hasClass('site-btn')){
            $(this).addClass('animate__fadeInUp animate__faster');
          }

          if($(this).hasClass('testimonial-carousel'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }

          if($(this).hasClass('testimonial-carousel'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }

          if($(this).hasClass('stat-wrapper') && $(this).hasClass('statistic-1'))
          {
            $(this).addClass('animate__fadeInUp animate__fast');
          }

          if($(this).hasClass('stat-wrapper') && $(this).hasClass('statistic-2'))
          {
            $(this).addClass('animate__fadeInDown animate__fast');
          }

          if($(this).hasClass('stat-wrapper') && $(this).hasClass('statistic-3'))
          {
            $(this).addClass('animate__fadeInUp animate__fast');
          }

          if($(this).hasClass('generic-content') || $(this).hasClass('content-after-columns'))
          {
            $(this).addClass('animate__fadeIn animate__slow');
          }
        }
      }
    });
  });

});
